module.exports = __webpack_public_path__ + "static/media/bbq-how-it-works.530b400f.jpg";